export default __webpack_public_path__ + "static/media/carta8.c6ac2267.png";